import EmptyMessage from './EmptyMessage/EmptyMessage'
import SortableList from './SortableList/SortableList'
import SortableWrapper from './SortableWrapper/SortableWrapper'
import VisibilityCriterionItem from './VisibilityCriterionItem/VisibilityCriterionItem'
import VisibilityCriterionItemSkeleton from './VisibilityCriterionItemSkeleton/VisibilityCriterionItemSkeleton'
import * as Styles from './styles'

const VisibilityCriterionItemList = ({
  isEditable,
  criteria,
  loading,
  onEdit,
  onDuplicate,
  onDelete,
  dragging,
  onSortStart,
  onSortEnd,
}) => {
  if (loading) return <VisibilityCriterionItemSkeleton />
  if (!criteria?.length) return <EmptyMessage />

  return (
    <SortableList items={criteria} onSortEnd={onSortEnd} onSortStart={onSortStart}>
      <Styles.Container>
        {criteria?.map((criterion, index) => (
          <SortableWrapper key={criterion.id} id={criterion.id} dragging={dragging} isEditable={isEditable}>
            <VisibilityCriterionItem
              criterion={criterion}
              index={index}
              isEditable={isEditable}
              onEdit={onEdit}
              onDuplicate={onDuplicate}
              onDelete={onDelete}
            />
          </SortableWrapper>
        ))}
      </Styles.Container>
    </SortableList>
  )
}

export default VisibilityCriterionItemList
